// extracted by mini-css-extract-plugin
export default {"zoomModal":"i1-z"};